import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ProcessSteps = ({ steps }) => {
  return (
    <Styles.Container>
      {steps.map((step, index) => (
        <Styles.Step key={index}>
          <Styles.StepMarker>{index + 1}</Styles.StepMarker>
          <Styles.StepContent>
            <Text type="bodyMRegular">
              <Text type="bodyMBold" tag="span">
                {step.title}:
              </Text>{' '}
              {step.description}
            </Text>
          </Styles.StepContent>
        </Styles.Step>
      ))}
    </Styles.Container>
  )
}

export default ProcessSteps
